/**
 * Translates raw eBay API errors into human-friendly Italian messages with
 * actionable suggestions. Pure function, safe to import anywhere.
 */
export function parseEbayError(rawError, article = null) {
  if (!rawError) return "Errore eBay sconosciuto";
  const txt = typeof rawError === "string" ? rawError : JSON.stringify(rawError);

  // 25001 — transient eBay outage
  if (txt.includes("25001") || txt.includes("magazzino principale")) {
    return "⏳ eBay è temporaneamente non disponibile (errore 25001 lato eBay). Riprova tra 1-2 minuti, di solito si risolve da solo.";
  }
  // 25002 — special case: missing photos (eBay requires ≥1 image)
  if (txt.includes("25002") && (txt.includes("foto") || txt.toLowerCase().includes("photo"))) {
    return "📷 Manca almeno 1 foto sull'articolo. Apri 'Modifica articolo' e carica almeno un'immagine, poi riprova a pubblicare.";
  }
  // 25002 — duplicate offer entity (we tried to create an offer that already exists)
  if (txt.includes("25002") || txt.includes("Entità proposta già esistente") || txt.includes("already exist")) {
    return "🔄 Offer eBay già esistente. Sto recuperando automaticamente l'offer orfana e riprovando. Clicca di nuovo 'Pubblica eBay' o 'Ripubblica errori'.";
  }
  // 25005 / 25709 — invalid category for marketplace
  if (txt.includes("25005") || txt.includes("25709") || txt.includes("categoryId") || txt.includes("category_id") || txt.includes("categoria non")) {
    const cat = article?.ebay_category_id ? ` (attuale: ${article.ebay_category_id})` : "";
    return `❌ Categoria eBay non valida per il marketplace IT${cat}. Apri "Modifica articolo" → sezione eBay → clicca "🔍 Suggerisci" per trovare la categoria GIUSTA in automatico, oppure prova: Modellini auto/camion 180273, Pokemon box 261044, Pokemon pacchetti 183456, Formula 1 2876.`;
  }
  // 25007 — condition
  if (txt.includes("25007") || txt.toLowerCase().includes("condition")) {
    return "❌ Condizione articolo non valida per eBay. Modifica l'articolo e scegli: NEW / NEW_OTHER / USED_EXCELLENT.";
  }
  // 25011 — missing aspect
  if (txt.includes("25011") || txt.includes("aspect") || txt.includes("specifica")) {
    return "❌ Mancano specifiche eBay obbligatorie (Marca, Scala, Materiale...). Modifica l'articolo e usa l'AI Describer per compilarle.";
  }
  // Token/auth issues
  if (txt.toLowerCase().includes("token") || txt.toLowerCase().includes("unauthorized")) {
    return "🔐 Token eBay scaduto o non valido. Vai nel tab 'eBay' e ricollega l'account.";
  }
  // Generic 504/timeout
  if (txt.toLowerCase().includes("timeout") || txt.includes("504") || txt.includes("502")) {
    return "⏱️ Timeout di comunicazione con eBay. Riprova fra qualche secondo.";
  }
  // Fallback
  const short = txt.replace(/\s+/g, " ").slice(0, 200);
  return `Errore eBay: ${short}${txt.length > 200 ? "…" : ""}`;
}
